export default __webpack_public_path__ + "static/media/tutorial4-6.54762dcb.png";